import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class CompositionAppService extends RestfulService<Models.CompositionApp> {

  constructor(private restService: RestService) {
    super(Models.CompositionApp);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('composition-apps');
  }

}
